// extracted by mini-css-extract-plugin
module.exports = {"dragDropFile":"styles-module_dragDropFile__C3PtsxqUS_RoU7ZKerb7"};